angular.module('impactx.rfx').controller('RFQCListCtrl', [
    'dataGen',
    '$route',
    'selectedListItems',
    'ToastService',
    RFQCListCtrl]);

function RFQCListCtrl(dataGen, $route, selectedListItems, ToastService) {
    var ctrl = this;

    this.getCopyLink = function() {
        return "rfqcedit/" + selectedListItems.getFirstSelectedId() + "/true";
    };

    this.getDetailLink = function() {
        return "rfqcedit/" + selectedListItems.getFirstSelectedId();
    };

    this.getHistoryLink = function() {
        return "rfqchistorylist/" + selectedListItems.getFirstSelectedItem().baseNo;
    };

    this.canDeactivate = function()
    {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().status == 1;
    };

    this.canActivate = function()
    {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canBeActivated.value;
    };

    this.activate = function() {
        var temp = {};
        dataGen.postAsForm(temp, {
            rfqcId: selectedListItems.getFirstSelectedId()
        }, "/rfx/activate").then(function () {
            ToastService.openStandardToast(temp.trns.activateSuccess);
            $route.reload();
        });
    };

    this.deactivate = function() {
        var temp = {};
        dataGen.postAsForm(temp, {
            rfqcId: selectedListItems.getFirstSelectedId()
        }, "/rfx/deactivate").then(function () {
            ToastService.openStandardToast(temp.trns.deactivateSuccess);
            $route.reload();
        });
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFQCView'},
        {label: "history", linkFunction: ctrl.getHistoryLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFQCView'},
        {label: "copyConfiguration", linkFunction: ctrl.getCopyLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFQCEdit'},
        {
            label: "activate",
            action: ctrl.activate,
            condition: ctrl.canActivate,
            process: 'RFQCEdit'
        },
        {
            label: "deactivate",
            action: ctrl.deactivate,
            condition: ctrl.canDeactivate,
            process: 'RFQCEdit'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/rfx/templates/rfqclist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/listrfqc',
        id: "rfqclist",
        mainAction: {id: "new", link: "#/rfqcedit/0", icon: "mdi-plus"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}
